import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Languages } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getHomepageSectionML } from '../../services/api';
import ArticleCard from '../cards/ArticleCard';

const AUTO_LABEL = {
  en: 'Some content auto-translated',
  pt: 'Algum conteúdo traduzido automaticamente',
  fr: 'Contenu partiellement auto-traduit',
  ar: 'بعض المحتوى مترجم تلقائيًا',
  zh: '部分内容由系统自动翻译',
};

const InsightsSectionML = () => {
  const { language } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInsightsContent();
  }, [language]);

  const loadInsightsContent = async () => {
    setLoading(true);
    const normalizedLang = ['pt','en','fr','ar','zh'].includes(language) ? language : (language.startsWith('pt') ? 'pt' : 'en');
    const result = await getHomepageSectionML('insights', normalizedLang);
    if (result.success) {
      setContent(result.data);
    }
    setLoading(false);
  };

  if (loading || !content) {
    const loadingText = { pt: 'A carregar...', en: 'Loading...', fr: 'Chargement...', ar: 'جارٍ التحميل...', zh: '加载中...' }[language] || 'Loading...';
    return (
      <section className="bg-white py-24">
        <div className="container mx-auto px-6 text-center">
          <div className="animate-pulse">{loadingText}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-white py-24">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16">
          <div>
            <div className="flex items-center gap-3 flex-wrap mb-4">
              <p className="text-xs font-semibold uppercase tracking-widest text-[#00B4D8]">
                {content.label}
              </p>
              {content._auto_translated && (
                <span
                  className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-50 text-amber-700 border border-amber-200 text-[10px] font-semibold uppercase tracking-wider rounded"
                  data-testid="insights-section-auto-translated"
                  title={AUTO_LABEL[language] || AUTO_LABEL.en}
                >
                  <Languages className="w-3 h-3" /> {AUTO_LABEL[language] || AUTO_LABEL.en}
                </span>
              )}
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#2B2D42]">
              {content.heading}
            </h2>
          </div>
          <Link
            to="/insights"
            className="mt-4 md:mt-0 text-base font-semibold text-[#00B4D8] hover:underline inline-flex items-center gap-2 group"
          >
            {content.view_all_text}
            <span className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {content.articles?.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsSectionML;
